import React from 'react'
import Table, { Cell, Header, Row } from 'components/Table'
import '../style.scss'

const Seller = (props) => {
  const { redelivery } = props

  return (
    <div className="purchase-container">
      <div className="seller-title">
        Seller: <strong>{redelivery?.sellers?.[0]?.name}</strong>
      </div>
      <div className="scrollable-table">
        <Table>
          <Header>
            <Cell>SKU</Cell>
            <Cell>Item Name</Cell>
            <Cell>Ordered Quantity</Cell>
            <Cell>Fulfilled Quantity</Cell>
            <Cell>Subject to GST</Cell>
            <Cell className="text-right">Unit Price</Cell>
            <Cell className="text-right">Total Price</Cell>
          </Header>
          {redelivery?.items?.map((item) => (
            <Row key={item.id}>
              <Cell>{item?.sku}</Cell>
              <Cell>{item?.name}</Cell>
              <Cell className="text-center">{item?.orderedQuantity}</Cell>
              <Cell className="text-center">
                {item?.fulfilledQuantity || '-'}
              </Cell>
              <Cell className="text-center">
                {item?.isSubjectToGst ? 'Yes' : 'No'}
              </Cell>
              <Cell className="text-right">${item?.unitPrice}</Cell>
              <Cell className="text-right">${item?.payableAmount}</Cell>
            </Row>
          ))}
        </Table>
      </div>
    </div>
  )
}

export default Seller
